import React, { Fragment, useEffect, useState} from 'react'
import {
  makeStyles,
  Typography,
  CircularProgress,
  Card,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import roiStandIn from '../../assets/homeStandIns/roiStandIn.png'
import AskReport from '../AskReport'
import moment from 'moment'
import DonutChart from '../charts/DonutChart'

const getClasses = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  caption: {
    textAlign: 'center'
  },
  loader: {
    marginLeft: '45%',
    marginTop: '30%',
  },
  data: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'space-evenly'
  },
  statGroup: {
    width: '30%',
    marginLeft: '30px'
  },
  stats: {
    fontWeight: 'bold',
    color: '#626262',
    [theme.breakpoints.up('xl')]: {
      fontSize: 16
    }
  },
  statsDark: {
    fontWeight: 'bold',
    color: '#fff',
    [theme.breakpoints.up('xl')]: {
      fontSize: 16
    }
  },
  pie: {
    paddingTop: 40,
  },
  divider: {
    opacity: 0.4,
  },
  customWidth: {
    maxWidth: 500,
  },
  standIn: {
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      marginTop: '-50px',
      height: '35%',
      width: '85%'
    },
    [theme.breakpoints.down('lg')]: {
      width: '120%',
      marginTop: '-35px'
    }
  },
  unavailable: {
    position: 'absolute',
    textAlign: 'center',
    marginTop: '100px'
  }
}))


export default function RoiPanel({name}) {
  const classes = getClasses()
  const [roiData, setRoiData] = useState(null)
  const [loading, setLoading] = useState(true)
  const token = Cookies.get('token')
  const today = moment().format('YYYY-MM-DD')
  const priorCalYear = moment().subtract(12, 'months').format('YYYY-MM-DD')

  const getRoiData = (roiName) => {
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${roiName}?startDate=${priorCalYear}&endDate=${today}`, {
      headers: {
        token: token
      }
    })

    request
    .then(response => response.json())
    .then(data => {
      if(data) {
        if(data[0].Data) {
          setRoiData(data[0].Data[0])
        } else {
          setRoiData()
        }

        // setLoading(false)
      } else {
        setRoiData([])
      }
    })
  }

  useEffect(() => getRoiData(name), [])

  if(loading) return <CircularProgress />

  const renderStats = (roiData) => {
    const { ADJ_Sales, ADJ_Resp, Sales, Responses } = roiData
    const stats = [
      {name: 'INC SALES', data: Math.round(ADJ_Sales).toLocaleString('en'), color: '#529c00'},
      {name: 'INC RESPONSES', data: Math.round(ADJ_Resp).toLocaleString('en'), color: '#942e92'},
      {name: 'AVG TICKET', data: Math.round(Sales / Responses).toLocaleString('en'), color: '#05b3ad'},
    ]

    return (
      <div className={classes.statGroup}>
        {stats.map(({name, data, color}, i) => (
          <Fragment key={`${name}-${i}`}>
            <h5 style={{color: `${color}`}}>{name}</h5>
            <span className={classes.stats}>{data}</span>
            <hr className={classes.divider} style={i === stats.length - 1 ? {display: 'none'} : {}}/>
          </Fragment>
        ))}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <p className={classes.caption}>
        On completed promotions, a total spend of <span style={{color: "rgba(255, 0, 0, 0.7)"}}>${Math.round(roiData.Cost).toLocaleString('en')}</span> has yielded <span style={{color: 'rgba(113, 177, 40)', fontWeight: 'bold'}}>${Math.round(roiData.Sales).toLocaleString('en')}</span> in sales to responders (at a {(roiData.Res_Rate * 100).toFixed(2)}% response rate)
      </p>
      <div className={classes.info}>
        {renderStats(roiData)}
        <DonutChart
          labels={['Total Spend', 'Incremental Sales']}
          data={[Math.round(roiData.Cost), Math.round(roiData.ADJ_Sales)]}
          colors={['rgba(235, 82, 82, 0.9)', 'rgba(110, 209, 0, 0.9)']}
          radius={'75%'}
          labelShow={true}
          legend={true}
          position={'bottom'}
        />
      </div>
    </div>
  )
}
